export default __webpack_public_path__ + "static/ece_monthly-66c591d7ff1c230e7abcf4844c073872.svg";